import React from 'react';
import ComingSoon from '../components/ComingSoon';
import './PageStyles.scss';

const Reports: React.FC = () => {
  return (
    <div className="hr-portal-page">
      <div className="hr-portal-page-header">
        <h2>Reports</h2>
        <p className="page-description">Generate and view HR reports and analytics</p>
      </div>
      <div className="hr-portal-page-content">
        <ComingSoon title="Coming Soon" />
      </div>
    </div>
  );
};

export default Reports;
